import { inject, Injectable } from '@angular/core';
import { Observable, map } from 'rxjs';
import { RouteDataService } from '@core/route-data/services/route-data.service';

@Injectable({
  providedIn: 'root',
})
export class MobileVersionManagerService {
  private readonly routeDataService = inject(RouteDataService);

  isMobileVersionDisabled(): Observable<boolean> {
    return this.routeDataService
      .getDataWithTheDeepestProperty('disableMobileVersion')
      .pipe(map(data => data?.disableMobileVersion ?? false));
  }
}
